export const COLOR_PALLETE = {
  bg: '#447087',
  sbg: '#4C6891',
  tbg: '#546FA6',
  pText: '#507395'
}